import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import { ContentViewerNavigation } from './ContentViewerNavigation';

interface ContentViewerNavigationPortalProps {
  contentRef: React.RefObject<HTMLElement>;
  useViewport?: boolean;
}

export const ContentViewerNavigationPortal: React.FC<ContentViewerNavigationPortalProps> = ({
  contentRef,
  useViewport = true,
}) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
    return () => setMounted(false);
  }, []);

  if (!mounted) return null;

  return ReactDOM.createPortal(
    <ContentViewerNavigation contentRef={contentRef} useViewport={useViewport} />,
    document.body,
  );
};
